import React from 'react';
import './AudioDurationCard.css';

const formatDuration = (seconds) => {
  if (!seconds || seconds === 0) return '0 сек';
  
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  
  const parts = [];
  if (hours > 0) parts.push(`${hours} ч`);
  if (minutes > 0) parts.push(`${minutes} мин`);
  if (secs > 0 || parts.length === 0) parts.push(`${secs} сек`);
  
  return parts.join(' ');
};

const AudioDurationCard = ({ data = {} }) => {
  const {
    totalAudioSources = 0,
    averageDuration = 0,
    medianDuration = 0
  } = data;

  return (
    <div className="audio-stats-grid">
      <div className="audio-stat-card">
        <div className="audio-stat-header">
          <h3>Источники аудио</h3>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="1"></circle>
            <path d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18"></path>
          </svg>
        </div>
        <div className="audio-stat-value">{totalAudioSources}</div>
        <div className="audio-stat-meta">всего источников</div>
      </div>

      <div className="audio-stat-card">
        <div className="audio-stat-header">
          <h3>Средняя длина</h3>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14.4 14.4L9.6 9.6"></path>
            <circle cx="12" cy="12" r="10"></circle>
          </svg>
        </div>
        <div className="audio-stat-value">{formatDuration(averageDuration)}</div>
        <div className="audio-stat-meta">среднее значение</div>
      </div>

      <div className="audio-stat-card">
        <div className="audio-stat-header">
          <h3>Медиана</h3>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <polyline points="19 12 12 19 5 12"></polyline>
          </svg>
        </div>
        <div className="audio-stat-value">{formatDuration(medianDuration)}</div>
        <div className="audio-stat-meta">центральное значение</div>
      </div>
    </div>
  );
};

export default AudioDurationCard;
